export default __webpack_public_path__ + "static/media/notif_emote_icon.74db4ecd.svg";